import * as React from 'react';
import { FormControl, InputLabel, MenuProps, Select, SelectChangeEvent } from '@mui/material';

interface CustomDropdownPropsType {
  id?: string;
  label?: string;
  labelId?: string;
  value?: string;
  defaultValue?: string;
  isFullWidth?: boolean;
  children?: React.ReactNode;
  customStyle?: React.CSSProperties; // example { paddingBottom: "10px" }
  menuProps?: Partial<MenuProps>; // example { paddingBottom: "10px" }
  handleChange: (event: SelectChangeEvent<string>, child: React.ReactNode) => void;
  handleBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  error?: string;
  showAsterisk?: boolean;
  name?: string;
}

export default function CustomDropdown(props: CustomDropdownPropsType) {
  return (
    <FormControl
      fullWidth
      sx={{
        '& .MuiOutlinedInput-root': { boxShadow: '0px 0px 40px 0px rgb(0 0 0 / 10%) !important' },
        marginBottom: props.customStyle?.marginBottom ? props.customStyle.marginBottom : '15px',
      }}
    >
      <InputLabel id={props.labelId} sx={{ marginTop: '-2px' }}>
        {props.label}
        {props.showAsterisk && <span style={{ color: 'red' }}>*</span>}
      </InputLabel>
      <Select
        labelId={props.labelId}
        id={props.id}
        value={props.value}
        label={props.label}
        defaultValue={props.defaultValue}
        onChange={props.handleChange}
        onBlur={props.handleBlur}
        MenuProps={props.menuProps}
        name={props.name}
        style={{
          borderRadius: '24px',
          height: '49px',
          backgroundColor: !!props.error ? 'pink' : 'white',
          width: '100%',
          ...(props.customStyle || {}),
        }}
        error={!!props.error}
      >
        {props.children}
      </Select>
    </FormControl>
  );
}
